export const css = `
.csb-api-body * {
  box-sizing: content-box;
  box-sizing: initial;
  -webkit-font-smoothing: antialiased;
}

.csb-api-lbA-dBW {
  position: fixed;
  inset: 0px;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.75);
}

.csb-api-ejhIWQ {
  display: flex;
  flex-flow: row nowrap;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.csb-api-gDXMLZ {
  box-sizing: border-box;
}

.csb-api-iKKeUp {
  box-sizing: border-box;
  background-color: rgb(29, 29, 29);
  border-radius: 4px;
  overflow: hidden;
  margin: auto;
  padding: 24px;
  width: 100%;
  box-shadow: rgb(0 0 0 / 12%) 0px 4px 4px, rgb(0 0 0 / 24%) 0px 16px 32px;
}

.csb-api-bLQEZt {
  display: flex;
  flex-flow: column nowrap;
}

.csb-api-ehPhEd {
  width: 100%;
  height: 100%;
  padding: 48px 0px;
  color: rgb(255, 255, 255);
}

.csb-api-hlNCCE {
  font-size: 12px;
  text-align: center;
  line-height: normal;
  display: block;
  color: rgb(153, 153, 153);
}

.csb-api-iAmNcN {
  line-height: 13px;
  max-width: 240px;
  margin: 12px 0px 0px;
}

.csb-api-iZHgQj {
  display: flex;
  flex-flow: column nowrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}

.csb-api-iZHgQj > :not(:last-child) {
  margin-bottom: 0px;
}

.csb-api-icIAxa {
  display: flex;
  flex-flow: column nowrap;
}

.csb-api-icIAxa > :not(:last-child) {
  margin-bottom: 32px;
}

.csb-api-czzOfk {
  display: flex;
  flex-flow: column nowrap;
}

.csb-api-czzOfk > :not(:last-child) {
  margin-bottom: 12px;
}



.csb-api-fTbnP {
  font-size: 48px;
  text-align: left;
  font-weight: 500;
  line-height: normal;
  display: inline;
  color: inherit;
}

.csb-api-bGcgTK {
  text-align: center;
  line-height: 1.5;
  opacity: 0.6;
}

.csb-api-iqUtWS {
  font-size: 16px;
  text-align: center;
  line-height: normal;
  display: inline;
  color: inherit;
}

csb-api-body button {
  -webkit-appearance: button;
}

.csb-api-iMjrFU {
  width: 150px;
  height: auto;
  display: flex;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 4px;
  gap: 4px;
  color: rgb(21, 21, 21);
  background: rgb(237, 255, 165);
  border: 1px solid rgb(237, 255, 165);
  outline: none;
}

.csb-api-hJQayb {
  box-sizing: border-box;
  padding: 4px 8px;
  background-color: rgb(234, 255, 150);
  color: rgb(14, 14, 14);
  display: inline-flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  flex: 0 0 auto;
  font-family: Inter, sans-serif;
  width: 100%;
  height: 28px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease 0s, color 0.3s ease 0s;
  text-decoration: none;
}

.csb-api-body svg:not(:root) {
  overflow: hidden;
}

.csb-api-boqSVd {
  line-height: 1;
}

.csb-api-bGdKhk {
  font-size: 16px;
  text-align: left;
  font-weight: 500;
  line-height: normal;
  display: inline;
  color: inherit;
}

.csb-api-jgbWPj {
  display: flex;
  flex-flow: row nowrap;
}

.csb-api-jgbWPj > :not(:last-child) {
  margin-right: 12px;
}

.csb-api-qLSHt {
  width: 100%;
  height: 40px;
  flex: 1 1 0%;
}

.csb-api-gKSYze {
  width: 150px;
  height: auto;
  display: flex;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 4px;
  gap: 4px;
  color: rgb(153, 153, 153);
  background: rgb(42, 42, 42);
  border: 1px solid rgb(55, 55, 55);
  outline: transparent solid 2px;
}

.csb-api-ikXgsJ {
  line-height: 1;
}

.csb-api-iRVciZ {
  font-size: 13px;
  text-align: left;
  font-weight: 500;
  line-height: normal;
  display: inline;
  color: inherit;
}
.csb-api-kBXWKy {
  width: 100%;
  height: 40px;
  flex: 1 1 0%;
}

.csb-api-IWxWu {
  line-height: 1;
}

.csb-api-idcsSp {
  line-height: 13px;
  max-width: 200px;
  margin: 24px 0px 0px;
}

.csb-api-bzsMqS {
  font-size: 10px;
  text-align: center;
  line-height: normal;
  display: block;
  color: rgb(153, 153, 153);
}

.csb-api-gFqsi {
  width: 100%;
  height: 48px;
}

.csb-api-dxXsIr {
  max-width: 396px;
  margin: 0px;
  text-align: center;
  font-family: Everett, sans-serif;
  line-height: 1.17;
  letter-spacing: -0.018em;
}

.csb-api-modal {
  -webkit-box-flex: 1;
  flex-grow: 1;
  max-width: 720px;
  z-index: 9999;
}

.csb-api-idcsSp a {
  color: inherit;
}

.csb-api-overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: #0F0E0E;
  opacity: 0.4;
  animation: 100ms ease-in-out 0s 1 normal none running k-hGwPAG;
}

.csb-api-hJQayb[disabled] {
  opacity: 0.8;
}

.csb-api-iaWCwi {
  display: flex;
  flex-flow: column;
  -webkit-box-align: center;
  align-items: center;
}

.csb-api-efjlMo {
  font-size: inherit;
  text-align: left;
  line-height: normal;
  display: inline;
  color: inherit;
}

.csb-api-gHixVw {
  margin: 0px;
  text-align: center;
  font-family: Everett, sans-serif;
  font-size: 48px;
  font-weight: 500;
  line-height: 1.17;
}

.csb-api-iPhhHK {
  width: 100%;
  max-width: 420px;
}

.csb-api-bsZwCf {
  display: flex;
  flex-flow: column;
}

.csb-api-bsZwCf > :not(:last-child) {
  margin-bottom: 8px;
}

.csb-api-fygrRn {
  display: flex;
  flex-flow: column;
}

.csb-api-gFUkTC {
  box-sizing: border-box;
  padding: 4px 8px;
  background-color: rgb(234, 255, 150);
  color: rgb(14, 14, 14);
  height: 28px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  display: inline-flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  flex: 0 0 auto;
  font-family: Inter, sans-serif;
  width: 100%;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease 0s, color 0.3s ease 0s, box-shadow 0.3s ease 0s;
  text-decoration: none;
}

.csb-api-gFUkTC:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.csb-api-fWRCGd {
  width: 100%;
  height: 48px;
}



.csb-api-CmLhy:disabled {
  color: rgb(153, 153, 153);
  cursor: not-allowed;
  border-color: rgb(36, 36, 36);
}


.csb-api-CmLhy {
  height: 28px;
  width: 100%;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 13px;
  line-height: 16px;
  font-family: Inter, sans-serif;
  border-radius: 4px;
  background-color: rgb(37, 37, 37);
  border: 1px solid rgb(36, 36, 36);
  color: rgb(245, 245, 245);
  transition: all 100ms ease 0s;
  appearance: none;
}

.csb-api-ejERkE:disabled {
  opacity: 1;
}

.csb-api-CmLhy:hover, .csb-api-CmLhy:focus {
  border-color: rgb(149, 129, 255);
  outline: none !important;
}

.csb-api-ejERkE {
  height: 100%;
  padding: 16px;
}

.csb-api-jWVHRd {
  position: absolute;
  height: fit-content;
  background: rgb(37, 37, 37);
  padding: 2px;
  inset: 0px 16px 0px auto;
  margin: auto 0px;
}

.csb-api-bAQRhy {
  color: rgb(237, 108, 108);
}

.csb-api-eoHNwX {
  box-sizing: border-box;
  flex-shrink: 0;
}

svg:not(:root) {
  overflow: hidden;
}

.csb-api-gFehFv {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.005em;
  color: rgb(239, 122, 122);
}


.csb-api-hjGqFO {
  box-sizing: border-box;
  padding: 4px 8px;
  background-color: transparent;
  color: rgb(219, 219, 219);
  height: 28px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  display: inline-flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  flex: 0 0 auto;
  font-family: Inter, sans-serif;
  width: 100%;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease 0s, color 0.3s ease 0s, box-shadow 0.3s ease 0s;
  text-decoration: none;
}

.csb-api-eYNxpT {
  all: unset;
  text-decoration: underline;
  transition: color 0.3s ease 0s;
}

.csb-api-kBqEPL {
  display: flex;
  flex-flow: column;
  -webkit-box-align: center;
  align-items: center;
}

.csb-api-hyGEHp {
  font-size: 13px;
  text-align: left;
  line-height: 16px;
  display: inline;
  color: rgb(153, 153, 153);
}



.csb-api-bIjkRi {
  box-sizing: border-box;
  padding: 4px 8px;
  background-color: transparent;
  color: rgb(219, 219, 219);
  height: 28px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  display: inline-flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  flex: 0 0 auto;
  font-family: Inter, sans-serif;
  width: 100%;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease 0s, color 0.3s ease 0s, box-shadow 0.3s ease 0s;
  text-decoration: none;
}
.csb-api-iaWCwi > :not(:last-child) {
  margin-bottom: 32px;
}

.csb-api-cIOuzf {
  line-height: 1;
}

.csb-api-ljdegr {
  padding: 4px;
  width: fit-content;
  margin-top: 12px;
}

.csb-api-iAmNcN a {
  color: inherit;
}
`;
//# sourceMappingURL=loginModalUICss.js.map